export const RegularIslandSVG = ({
    fillColor = "#c7c7c7",
    borderColor = "#4c4c4c",
    contrastColor = "#4CAF50",
    width = 34,
    height = 20,
}) => {
    const viewBox = "0 0 40 40";
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 200 280"
            role="img"
            aria-labelledby="lumpyBagTitle"
            version="1.1"
            id="svg5"
            xmlns="http://www.w3.org/2000/svg">
            <title id="lumpyBagTitle">Icono de Bolsa de Basura (Forma Real e Imperfecta)</title>
            <path
                d="M 95,35
                C 70,35 40,55 35,110
                C 32,140 25,170 28,190
                C 30,220 50,235 80,230
                C 100,225 125,245 155,235
                C 175,225 180,180 175,130
                C 170,80 150,40 125,38
                C 110,36 100,35 95,35
                Z"
                id="path1"
                fill={fillColor}
                fillOpacity="1"
                stroke={borderColor}
                strokeOpacity="1"
                strokeWidth="5"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
            <path
                d="M 65,110 C 80,105 95,115 110,110"
                id="path2"
                stroke={borderColor}
                strokeOpacity="1"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                d="M 80,150 C 95,145 110,155 125,150"
                id="path3"
                stroke={borderColor}
                strokeOpacity="1"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                d="M 60,190 C 75,185 90,195 105,190"
                id="path4"
                stroke={borderColor}
                strokeOpacity="1"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path
                stroke={borderColor}
                strokeWidth="5"
                strokeOpacity="1"
                fill="none"
                d="M 88,35
                C 75,20 82,5 95,8
                C 105,10 100,25 95,35
                M 112,35
                C 125,15 140,25 130,40
                C 125,48 115,40 112,35
                Z"
                id="path5"
            />
            <metadata id="metadata5"></metadata>
        </svg>
    );
};
